<template>
  <main-layout selectedMenu="explore">
    <div class="parentNode">
      <div class="parentdiscuss">
        <div class="discussdetails">
          <p class="fromtowhere">
            {{$t('global.来自')}}
            <router-link
              :to="`/subjectdetail/${topicId}/home`"
            >{{answerResponse.questionDomain&&answerResponse.questionDomain.topicTitle}}{{$t('global.的讨论区')}}</router-link>
          </p>
          <div class="leavemessage">
            <ul>
              <li>
                <p
                  class="titles"
                  style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;"
                >{{answerResponse.questionDomain.title}}</p>
                <div class="usermessage">
                  <router-link :to="'/peopleCenter/'+answerResponse.questionDomain.userId">
                    <img
                      class="userhead"
                      :src="answerResponse.userAccountDomain.avatar | imageUrl('/static/profile_img_default.png',40,40)"
                    />
                  </router-link>

                  <div class="name">
                    <p>{{answerResponse.userAccountDomain.nickName}}</p>
                    <p>
                      <span>{{timeStamp(answerResponse.questionDomain&&answerResponse.questionDomain.createTime - 28800000)}}</span>
                    </p>
                  </div>
                  <a
                    class="attention"
                    @click="Follow(answerResponse)"
                    v-show="answerResponse.userAccountDomain.id != currentUser.userId"
                  >{{!answerResponse.isFollow?$t('global.关 注'):$t('global.取消关注')}}</a>
                  <div
                    class="rightside"
                    v-show="answerResponse.userAccountDomain.id == currentUser.userId"
                  >
                    <router-link
                      :to="`/publishPage?id=${questionId}&topicId=${topicId}&typeId=${answerResponse.questionDomain.typeId}&topicName=${topicName}`"
                    >
                      <img class="modify" src="/static/modify.svg" />
                    </router-link>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="detailcontent">
            <p class="textdescription" v-html="answerResponse.questionDomain.content"></p>
            <div class="clearfix"></div>
            <div class="attentionshare">
              <span class="collect0" :class="{addcollect0:isAddCollect0}" @click="like(0)"></span>
              <a>{{answerResponse.questionDomain.likeCount}}</a>
              <span class="collect1" :class="{addcollect1:isAddCollect1}" @click="like(1)"></span>
              <a>{{answerResponse.questionDomain.collectionCount}}</a>
              <span @click="shareCkeck()">
                <img src="/static/shareicon.svg" />
                <a>{{$t('global.分享')}}</a>
              </span>

              <div class="dotdel">
                <span @click="showReport(answerResponse.userAccountDomain)">...</span>
                <div class="dotdisplay" :style="{'display':isReport?'block':'none'}">
                  <p @click="showReportV(null)">{{$t('global.举报')}}</p>
                  <p
                    @click="deleteQuestion()"
                    v-show="answerResponse.userAccountDomain.isDelete"
                  >{{$t('global.删除')}}</p>
                </div>

                <report-dialog
                  :questionId="questionId"
                  report-type="0"
                  :report-visible="reportVisible"
                  @update-after="afterReport"
                  @close-after="afterReport"
                ></report-dialog>
              </div>
            </div>
            <div class="parentShare">
              <share
                :config="config"
                :class="{animated:isWinsup,bounceInUp:istp140,closeshare:iscloseShare}"
                id="sharefrienf"
              ></share>
            </div>

            <div class="comment">
              <p class="commentnum">
                <span>{{answerResponse.questionDomain.answerCount}}</span>
                {{$t('global.回复')}}
              </p>
              <!--已登录-->
              <div class="sendcomment" v-if="isLoading">
                <div>
                  <img :src="currentUser.avatar | imageUrl('/static/profile_img_default.png',40,40)" />
                  <textarea
                    class="commentBox"
                    type="text"
                    :placeholder="$t('global.写下你的回复')"
                    v-model="answerForm.content"
                  ></textarea>
                </div>
                <p>
                  <a @click="saveAnswer">{{$t('detail.回复')}}</a>
                </p>
              </div>
              <!--未登录-->
              <div class="nosendcomment" v-else>
                <p>
                  <router-link to="/Login">{{$t('global.登录')}}</router-link>
                  {{$t('global.或')}}
                  <router-link to="/Reg">{{$t('global.注册')}}</router-link>
                  ，{{$t('global.说说你的看法')}}
                </p>
              </div>
            </div>

            <div class="usercommerlist">
              <div class="aboutcommerlist">
                <ul>
                  <li v-for="(item,index) in answerResponse.answerList.list" :key="index">
                    <router-link target="_blank" :to="'/peopleCenter/'+item.userId">
                      <img class="userlogo" :src="item.avatar |  imageUrl('/static/profile_img_default.png',40,40)" />
                    </router-link>
                    <div class="rightcomment">
                      <div class="firstrow">
                        <router-link
                          target="_blank"
                          :to="'/peopleCenter/'+item.userId"
                          class="name"
                        >{{item.nickName}}</router-link>
                        <span>{{timeStamp(item.createTime == ''?item.updateTime - 28800000 : item.createTime - 28800000 )}}</span>
                      </div>
                      <div class="lastrow">
                        <span class="message">{{item.content}}</span>
                        <div class="righticon">
                          <img @click="getChildAnswerList(item.id)" src="/static/reply.svg" />
                          <a>{{item.answerCount}}</a>
                          <span class="zan" :class="{nozan:item.isLike}" @click="answerLike(item)"></span>
                          <a>{{item.likeCount}}</a>
                          <div class="judelbtn">
                            <span @click="showItemReport(item)">...</span>
                            <div
                              class="judelbtnitem"
                              :style="{'display':item.isReport?'block':'none'}"
                            >
                              <p @click="showReportV(item)">{{$t('global.举报')}}</p>
                              <p
                                v-if="answerResponse.isDelete ||  currentUser.userId == item.userId"
                                @click="deleteAnswer(item)"
                              >{{$t('global.删除')}}</p>
                            </div>

                            <report-dialog
                              :questionId="item.id"
                              report-type="1"
                              :report-visible="item.reportVisible"
                              :item="item"
                              @update-after="afterReport"
                              @close-after="afterReport"
                            ></report-dialog>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="replyshowbox" v-if="answerParentId == item.id && replyshowbox">
                      <div class="replycomment">
                        <!--用户的第一条评论-->
                        <div
                          class="commentstyle"
                          v-for="(childItem,index) in item.childDomain.list"
                          :key="index"
                        >
                          <p>
                            <strong>{{childItem.nickName}}</strong>
                            <span>{{timeStamp(childItem.createTime == ''?childItem.updateTime : childItem.createTime )}}</span>
                          </p>
                          <p>{{childItem.content}}</p>
                        </div>
                      </div>
                      <span
                        v-show="answerPagerParam.hasNextPage"
                        @click="loadMoreAnswer"
                      >{{$t('global.查看更多')}}</span>
                      <textarea
                        :placeholder="$t('global.请输入回复内容')"
                        v-model="childAnswerForm.content"
                      ></textarea>
                      <span>5000</span>
                      <div class="showboxbtn">
                        <a @click="cancelbtn">{{$t('global.取消')}}</a>
                        <a @click="saveChildAnswer(item)">{{$t('detail.回复')}}</a>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <pages
            :page-size="pagerParam.pageSize"
            :page-count="pagerParam.pageCount"
            :current-page.sync="pagerParam.currentPage"
            :total="pagerParam.total"
            @current-page-changed="OnCurrentPageChanged"
          ></pages>
        </div>

        <!--右侧放这-->
        <div style="height: auto;">
          <subject-detail-right
            :active-index="activeIndex"
            :topic-id="topicId"
            :is-more="false"
            :topic-name="topicName"
            :is-create="answerResponse.isCreate"
            ref="subjectDetailRight"
            @change-index="changeIndex(4)"
          ></subject-detail-right>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import pages from "../../components/pages.vue";
import SubjectDetailRight from "./SubjectDetailRight";
import ReportDialog from "../../components/topic/ReportDialog";
/*import VueQArt from 'vue-qart';*/
import Share from "vue-social-share";
import "vue-social-share/dist/client.css";

export default {
  name: "discussDetails",
  metaInfo() {
    return {
      title: this.$t("global.问答详情") + " | MANA"
    };
  },
  components: {
    ReportDialog,
    SubjectDetailRight,
    MainLayout,
    pages,
    /*VueQArt,*/
    Share
  },
  data() {
    return {
      replyshowbox: false,
      questionId: -1,
      isActive: 0,
      activeIndex: 0,
      acIndex: 0,
      childIndex: 0,
      isDishare: false,
      isWinsup: false,
      iscloseShare: false,
      istp140: false,
      //隐藏显示 share
      isShowSchare: false,
      //显示举报
      isReport: false,
      reportVisible: false,

      answerResponse: {
        questionDomain: {},
        userAccountDomain: {},
        answerList: {}
      },
      topicName: "",
      answerForm: { content: "", topicQuestionId: "", id: "", topicId: "" },
      childAnswerForm: {
        content: "",
        topicQuestionId: "",
        parentId: "",
        id: "",
        topicId: ""
      },
      pagerParam: {
        pageSize: 10,
        pageCount: 1,
        currentPage: 1,
        total: 1
      },
      answerPagerParam: {
        pageSize: 5,
        pageCount: 1,
        currentPage: 1,
        total: 1
      },
      answerParentId: 0,
      currentUser: this.$store.state.peopleMessage,
      topicId: 0,

      isAddCollect0: false,
      isAddCollect1: false,

      isLoading: false,
      config: {
        url: location.href.replace(/&topicName=[^#]*/, ""),
        disabled: [
          "tencent",
          "google",
          "facebook",
          "twitter",
          "linkedin",
          "diandian"
        ]
      },
      remnant: 5000
    };
  },
  created() {
    this.topicId = this.$route.query.topicId;
    /*this.topicName = this.$route.query.topicName;*/
    this.activeIndex = +this.$route.query.activeIndex;
    this.questionId = this.$route.query.id;
    this.answerForm.topicQuestionId = this.questionId;
    this.getAnswerInfo();
    this.isLoadingOut();
  },
  methods: {
    changeIndex(index, cIndex) {
      this.acIndex = index;
      this.childIndex = cIndex;
      switch (index) {
        case 4:
          this.$router.push("subjectdetail?id=" + this.topicId + "&page=4");
          break;
      }
    },

    isLoadingOut() {
      if (!localStorage.getItem("auth_token")) {
        this.isLoading = false;
      } else {
        this.isLoading = true;
      }
    },
    //显示问题举报弹框
    showReportV(item) {
      if (item == null) {
        this.reportVisible = true;
        this.isReport = false;
      } else {
        this.$set(item, "reportVisible", true);
        this.$set(item, "isReport", false);
      }
    },
    //举报问题之后
    afterReport(item) {
      debugger;
      if (item == null) {
        this.reportVisible = false;
      } else {
        this.$set(item, "reportVisible", false);
        this.$set(item, "isReport", false);
      }
    },
    showReport(user) {
      this.isReport = !this.isReport;
      //验证是否有删除权限
      if (this.isReport) {
        if (this.currentUser.userId == user.id) {
          this.$set(user, "isDelete", true);
        } else {
          if (this.answerResponse.isDelete) {
            this.$set(user, "isDelete", true);
          } else {
            this.$set(user, "isDelete", false);
          }
        }
      }
    },
    showItemReport(item) {
      let i = false;
      //显示举报
      if (item.isReport == null) {
        this.$set(item, "isReport", !i);
      } else {
        this.$set(item, "isReport", !item.isReport);
      }

      //验证是否有删除权限
      if (item.isReport) {
        if (this.currentUser.userId == item.userId) {
          this.$set(item, "isDelete", true);
        } else {
          if (this.answerResponse.isDelete) {
            this.$set(item, "isDelete", true);
          } else {
            this.$set(item, "isDelete", false);
          }
        }
      }
    },
    deleteQuestion() {
      this.$confirm(this.$t("global.是否确定删除"), this.$t("global.提示"), {
        confirmButtonText: this.$t("global.确定"),
        cancelButtonText: this.$t("global.取消"),
        type: "warning"
      })
        .then(() => {
          var canDelete = this.answerResponse.isDelete;
          if (canDelete) {
            this.$http
              .post(
                "/api/u/topicquestion/delete?topicQuestionId=" +
                  this.answerResponse.questionDomain.id
              )
              .then(response => {
                if (response.code == "OK") {
                  this.$message.success(response.message);
                  this.$router.push(
                    `/subjectdetail?id=${this.answerResponse.questionDomain.topicId}&page=4`
                  );
                } else {
                  this.$message.error(response.message);
                }
              });
          } else {
            this.$message.error(this.$t("global.您没有权限删除"));
            this.isReport = false;
          }
        })
        .catch(() => {});
    },

    deleteAnswer(item) {
      this.$confirm(this.$t("global.是否确定删除"), this.$t("global.提示"), {
        confirmButtonText: this.$t("global.确定"),
        cancelButtonText: this.$t("global.取消"),
        type: "warning"
      })
        .then(() => {
          var canDelete = this.answerResponse.isDelete;
          if (canDelete || this.currentUser.userId == item.userId) {
            this.$http
              .post("/api/u/topicanswer/delete?topicAnswerId=" + item.id)
              .then(response => {
                debugger;
                if (response.code == "OK") {
                  this.$message.success(response.message);
                  this.getAnswerlist();
                  this.$set(item, "isReport", false);
                } else {
                  this.$message.error(response.message);
                }
              });
          } else {
            this.$message.error(this.$t("global.您没有权限删除"));
            this.$set(item, "isReport", false);
          }
        })
        .catch(() => {});
    },

    loadMoreAnswer() {
      if (this.answerPagerParam.hasNextPage) {
        this.getAnswerlist();
      }
    },
    Follow(item) {
      this.$http
        .post(
          `/api/u/relation/${!item.isFollow ? "follow" : "unfollow"}/${
            item.questionDomain.userId
          }`
        )
        .then(response => {
          if (response.code == "Unauthorized") {
            this.$refs.subjectDetailRight.publishbtn();
            return;
          }

          if (response) {
            item.isFollow = !item.isFollow;
            this.$message(response.message);
            this.$emit("follow", item);
          }
        });
    },
    answerLike(item) {
      debugger;
      let $this = this;
      this.$http
        .post("/api/u/topicanswer/like?topicAnswerId=" + item.id + "&type=" + 0)
        .then(response => {
          if (response.code == "OK") {
            if (item.isLike) {
              item.likeCount = item.likeCount - 1;
            } else {
              item.likeCount = item.likeCount + 1;
            }
            item.isLike = !item.isLike;
          } else {
            this.$message.error(response.data.message);
          }
        });
    },
    like(type) {
      let $this = this;
      this.$http
        .post(
          "/api/u/topicquestion/like?topicQuestionId=" +
            this.answerResponse.questionDomain.id +
            "&type=" +
            type
        )
        .then(response => {
          if (response.code == "OK") {
            if (type == 0) {
              $this.answerResponse.questionDomain.likeCount =
                response.data.likeCount;
              $this.answerResponse.islike =
                response.data.op == "add" ? true : false;
              this.isAddCollect0 = !this.isAddCollect0;
            } else {
              $this.answerResponse.questionDomain.collectionCount =
                response.data.collectionCount;
              $this.answerResponse.questionDomain.iscollect =
                response.data.op == "add" ? true : false;
              this.isAddCollect1 = !this.isAddCollect1;
            }
          } else if (response.code == "Unauthorized") {
            this.$refs.subjectDetailRight.publishbtn();
          } else {
            this.$message.error(response.data.message);
          }
        });
    },

    saveAnswer() {
      if (this.answerForm.content == "") {
        this.$message.error(this.$t("global.回复内容不能为空"));
        return;
      }
      let $this = this;
      this.answerForm.topicId = this.topicId;
      this.answerForm.topicQuestionId = this.questionId;
      this.$http
        .post("/api/u/topicanswer/create", this.answerForm)
        .then(response => {
          if (response.code == "OK") {
            $this.$message.success(this.$t("global.回复成功"));
            $this.answerForm = {};
          } else if (
            response.code == "401" &&
            response.message == this.$t("global.违禁")
          ) {
            this.$message.error(
              this.$t("global.存在违禁词") + "：" + response.data.errMessage
            );
          } else if (
            response.code == "401" &&
            response.message == this.$t("global.建议人工复审")
          ) {
            this.$message.success(
              `${this.$t("global.发布成功")}，${this.$t(
                "global.请等待人工审核"
              )}。`
            );
          } else {
            this.$message.error(response.data.message);
          }
        });
    },
    saveChildAnswer(parentItem) {
      if (parentItem != null) {
        if (this.childAnswerForm.content == "") {
          this.$message.error(this.$t("global.回复内容不能为空"));
          return;
        }
        let $this = this;
        this.childAnswerForm.parentId = parentItem.id;
        this.childAnswerForm.parentAnswerUserId = parentItem.userId;
        this.childAnswerForm.topicQuestionId = parentItem.topicQuestionId;
        this.childAnswerForm.topicId = this.topicId;
        this.$http
          .post("/api/u/topicanswer/create", this.childAnswerForm)
          .then(response => {
            if (response.code == "OK") {
              $this.answerParentId = parentItem.id;

              $this.$message.success(this.$t("global.回复成功"));
              $this.childAnswerForm = {};
            } else {
              this.$message.error(response.data.message);
            }
          });
      }
    },
    getChildAnswerList(id) {
      this.replyshowbox = true;
      this.answerParentId = id;
      let answerItem =
        this.answerResponse.answerList &&
        this.$jsonUtils.findRowByColAndVal(
          this.answerResponse.answerList.list,
          "id",
          this.answerParentId
        );
      if (answerItem != null) {
        this.answerPagerParam.currentPage = 1;
        this.$set(answerItem, "childDomain", null);
      }
      this.getAnswerlist();
    },
    getAnswerInfo() {
      this.$http
        .get("/api/topic/answerInfo", {
          params: { topicQuestionId: this.questionId }
        })
        .then(response => {
          this.answerResponse = response.data;
          const content = response.data.questionDomain.content;
          response.data.questionDomain.content = content.replace(
            /<iframe [^>]*>/g,
            a => {
              if (a.indexOf("video.manamana.net") !== -1) {
                let text = "";
                a.replace(/src="([^"]*)"/, (b, c) => {
                  text = `<video controls src=${c} style="width:100%;"><video>`;
                });
                return text;
              } else {
                return a;
              }
            }
          );
          let answerList = response.data.answerList;
          this.isAddCollect0 = this.answerResponse.isLike;
          this.isAddCollect1 = this.answerResponse.isCollect;
          this.pagerParam = {
            pageSize: answerList.pageSize,
            pageCount: answerList.totalPage,
            currentPage: answerList.pageIndex,
            total: answerList.totalRecord
          };
        });
    },
    getAnswerlist() {
      let $this = this;
      let params = {};
      if (this.answerParentId == 0) {
        params = {
          topicQuestionId: this.questionId,
          answerParentId: this.answerParentId,
          pageIndex: this.pagerParam.currentPage,
          pageSize: this.pagerParam.pageSize
        };
      } else {
        params = {
          topicQuestionId: this.questionId,
          answerParentId: this.answerParentId,
          pageIndex: this.answerPagerParam.currentPage,
          pageSize: this.answerPagerParam.pageSize
        };
      }

      this.$http
        .get("/api/topic/findAnswerList", { params: params })
        .then(response => {
          if ($this.answerParentId == 0) {
            $this.answerResponse.answerList.list = response.data.list;
            $this.answerPagerParam = {
              pageSize: response.data.pageSize,
              pageCount: response.data.totalPage,
              currentPage: response.data.pageIndex,
              total: response.data.totalRecord
            };
          } else {
            let answerItem =
              this.answerResponse.answerList &&
              $this.$jsonUtils.findRowByColAndVal(
                this.answerResponse.answerList.list,
                "id",
                this.answerParentId
              );
            if (answerItem != null) {
              $this.answerPagerParam = {
                pageSize: response.data.pageSize,
                pageCount: response.data.totalPage,
                currentPage: response.data.nextPage,
                total: response.data.totalRecord,
                hasNextPage: response.data.hasNextPage
              };

              if (answerItem.childDomain == null) {
                $this.$set(answerItem, "childDomain", response.data);
              } else {
                answerItem.childDomain.list.push(...response.data.list);
              }
            }
          }
        });
    },
    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val;
      this.answerParentId = 0;
      this.getAnswerlist();
    },

    cancelbtn() {
      this.replyshowbox = false;
    },

    shareCkeck() {
      this.istp140 = true;
      this.isDishare = true;
      this.isWinsup = true;
      if (!this.isShowSchare) {
        this.iscloseShare = false;
        document.getElementById("sharefrienf").style.display = "block";
      } else {
        this.iscloseShare = true;
        document.getElementById("sharefrienf").style.display = "none";
      }
      this.isShowSchare = !this.isShowSchare;
    }
  },

  watch: {
    "$store.state.accountUser"(val) {
      this.currentUser = val;
    },
    "answerResponse.questionDomain"(val) {
      this.topicName =
        this.answerResponse.questionDomain &&
        this.answerResponse.questionDomain.topicTitle;
      this.config = {
        url: location.href.replace(/&topicName=[^#]*/, ""),
        title: this.answerResponse.questionDomain.title,
        description: this.delHtmlTag(
          this.answerResponse.questionDomain.content.substr(0, 120)
        ),
        /*image:this.$jsonUtils.imageUrl(this.answerResponse.questionDomain.topicDomain.thumb),*/
        disabled: [
          "tencent",
          "google",
          "facebook",
          "twitter",
          "linkedin",
          "diandian"
        ]
      };
    }
  }
};
</script>

<style>
.parentNode {
  width: 100%;
  height: 100%;
  padding-top: 36px;
  background-color: #fff;
}
.parentdiscuss {
  width: 1160px;
  overflow: hidden;
  margin: 0 auto;
}
.fromtowhere {
  color: #999;
  font-size: 16px;
  margin-bottom: 30px;
}
.fromtowhere a {
  color: #4a90e2;
  margin-left: 10px;
  cursor: pointer;
  font-weight: bold;
}
.discussdetails {
  float: left;
  width: 760px;
  margin-top: 10px;
}
em {
  font-style: normal;
}
.leavemessage li {
  position: relative;
}
.leavemessage span.article {
  position: absolute;
  float: left;
  color: #fff;
  top: 4px;
  left: 0;
  font-size: 12px;
  padding: 1px 7px;
  border-radius: 3px;
}
.leavemessage span.article {
  background-color: #df7979;
}
.leavemessage li:last-child {
  margin-bottom: 15px;
}
.leavemessage .titles {
  width: 760px;
  color: #000;
  font-size: 22px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
}
.leavemessage .usermessage {
  height: 40px;
  margin-top: 20px;
  color: #999;
  font-size: 12px;
}
.leavemessage .usermessage .userhead {
  float: left;
  width: 40px !important;
  height: 40px !important;
  border-radius: 20px !important;
}
.leavemessage .usermessage .name {
  display: inline-block;
  float: left;
  max-width: 150px;
  height: 40px;
  color: #333;
  line-height: 16px;
  margin: 5px 30px 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.leavemessage .usermessage .name p:last-child {
  color: #999;
}
.leavemessage .usermessage .rightside {
  float: right !important;
  height: 26px !important;
  line-height: 26px !important;
}
.leavemessage .usermessage .rightside a {
  display: inline-block;
  height: 26px !important;
  line-height: 26px !important;
}

.leavemessage .usermessage .rightside .modify {
  position: relative;
  top: -13px;
  width: auto;
  height: 48px;
  cursor: pointer;
}

.leavemessage .usermessage .attention {
  float: left;
  display: inline-block;
  width: 64px;
  height: 30px;
  text-align: center;
  color: #fff;
  line-height: 30px;
  cursor: pointer;
  margin-top: 5px;
  background: rgba(35, 116, 255, 1);
  border-radius: 2px;
}

.detailcontent {
  padding-top: 15px;
}
.detailcontent .headlogo {
  width: 760px;
  height: auto;
  overflow: hidden;
  margin-bottom: 30px;
}
.detailcontent .headlogo img {
  max-width: 760px;
}
.textdescription {
  font-size: 16px !important;
  line-height: 28px;
  margin-bottom: 25px;
  overflow: hidden;
}
.textdescription p,
.textdescription a,
.textdescription span,
.textdescription em {
  font-size: 16px !important;
  text-align: left;
}
.textdescription p {
  overflow: hidden !important;
}
.textdescription img {
  /* width: 100%; */
}
.textdescription p:first-child {
  height: auto !important;
  margin-bottom: 10px;
  word-wrap: break-word;
}
.textdescription p:first-child span {
  float: left;
}
.textdescription > p > img {
  max-width: 100%;
}
.textdescription iframe {
  width: 100% !important;
  height: 427px;
}
iframe video {
  display: block;
  object-fit: fill;
}
.attentionshare img {
  float: left;
  width: 17px;
  height: 18px;
  vertical-align: middle;
  margin-right: 5px;
  cursor: pointer;
}
.attentionshare {
  position: relative;
  height: 18px;
  line-height: 18px;
  margin-bottom: 25px;
}
.attentionshare a {
  float: left;
  display: inline-block;
  margin-right: 25px;
  position: relative;
  top: 3px;
  cursor: pointer;
}
.attentionshare .dotdel {
  position: relative;
  float: left;
}
.attentionshare .dotdel > span {
  color: #999;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}

.commentnum {
  font-size: 18px;
  color: #000;
  margin-bottom: 20px;
}
.sendcomment {
  overflow: hidden;
  padding-bottom: 25px;
  border-bottom: 1px solid rgba(237, 236, 241, 1);
}
.sendcomment img {
  float: left;
  width: 38px;
  height: 38px;
  border-radius: 19px;
  margin: 0 30px 0 20px;
}
.sendcomment textarea {
  float: left;
  width: 672px;
  height: 100px;
  outline: none;
  font-size: 16px;
  border-radius: 3px;
  border: 1px solid #ddd;
  padding-left: 10px;
  background-color: #fcfcfc;
  box-sizing: border-box;
}
.sendcomment a,
.clickreplys a {
  float: right;
  display: inline-block;
  width: 98px;
  height: 36px;
  margin-top: 20px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
  line-height: 36px;
  border-radius: 3px;
  background-color: #2275ff;
}
.nosendcomment {
  height: 200px;
  font-size: 16px;
  text-align: center;
}
.nosendcomment p {
  padding-top: 90px;
}
.nosendcomment p a {
  cursor: pointer;
}
.usercommerlist {
  padding-top: 15px;
  min-height: 300px;
}
.usercommerlist .totallist {
  font-size: 14px;
  color: #777;
}
.usercommerlist .totallist span {
  font-size: 18px;
  color: #333;
}
.aboutcommerlist li {
  padding: 33px 0 33px 20px;
  border-bottom: 1px solid rgba(237, 236, 241, 1);
  box-sizing: border-box;
}
.aboutcommerlist li:last-child {
  margin-bottom: 30px;
  border-bottom: none;
}
.aboutcommerlist li .userlogo {
  float: left;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-radius: 20px;
  margin-right: 15px;
}
.aboutcommerlist li .rightcomment {
  float: left;
  width: calc(100% - 55px);
}
.rightcomment .firstrow .name {
  font-size: 14px;
  color: #333;
  cursor: pointer;
  font-weight: bold;
}
.rightcomment .firstrow .name + span {
  color: #999;
  font-size: 12px;
}
/*.rightcomment .firstrow .rightside{
    float: right;
    line-height: 22px;
    cursor: pointer;
  }
  .rightcomment .firstrow .rightside img{
    margin-right: 5px;
  }*/
.rightcomment .firstrow {
  position: relative;
  top: -5px;
}
.rightcomment .lastrow {
  margin-top: 10px;
  line-height: 19px;
}
.rightcomment .lastrow .message {
  color: #777;
  font-size: 14px;
}
.rightcomment .lastrow .righticon {
  float: right;
}
.rightcomment .lastrow .righticon img {
  width: 16px;
  height: 16px;
  cursor: pointer;
  margin: 0 10px 0 20px;
}
.rightcomment .lastrow .righticon span.zan {
  position: relative;
  top: 2px;
  margin-left: 5px;
  display: inline-block;
  width: 16px;
  height: 16px;
  background: url("/static/noszan.svg") no-repeat;
  background-size: cover;
}
.rightcomment .lastrow .righticon span.nozan {
  background: url("/static/zanicon.svg") no-repeat;
  background-size: cover;
}

.replyshowbox {
  width: calc(100% - 55px);
  margin-left: 55px;
}
.replyshowbox .replycomment {
  position: relative;
  margin-top: 20px;
  background-color: #f9f9f9;
  border: 1px solid #eee;
  border-radius: 3px;
  padding: 18px 15px;
}
.replyshowbox .replycomment:before {
  position: absolute;
  content: "";
  display: block;
  width: 10px;
  height: 10px;
  top: -7px;
  left: 30px;
  border: 1px solid #eee;
  border-right: none;
  border-bottom: none;
  transform: rotate(45deg);
  background-color: #f9f9f9;
}
.replyshowbox textarea {
  width: 100%;
  height: 136px;
  padding: 10px;
  outline: none;
  font-size: 14px;
  margin-top: 20px;
  border: 1px solid #eee;
  box-sizing: border-box;
}
.replyshowbox textarea + span {
  float: right;
  position: relative;
  top: -24px;
  right: 12px;
  font-size: 14px;
  color: #999;
}
.replyshowbox .showboxbtn {
  margin-top: 20px;
}
.replyshowbox .showboxbtn {
  text-align: right;
}
.replyshowbox .showboxbtn a {
  display: inline-block;
  width: 125px;
  height: 38px;
  text-align: center;
  color: #777;
  cursor: pointer;
  font-size: 14px;
  border-radius: 19px;
  line-height: 38px;
  border: 2px solid #777;
  box-sizing: border-box;
}
.replyshowbox .showboxbtn a:last-child {
  color: #0161ff;
  margin-left: 10px;
  border: 2px solid #0161ff;
}
.commentstyle strong {
  font-size: 14px;
  color: #333;
}
.commentstyle strong + span {
  color: #999;
  font-size: 12px;
  margin-left: 5px;
}
.commentstyle > p {
  margin-bottom: 5px;
}
.commentstyle {
  margin-bottom: 10px;
}
commentstyle:last-child {
  margin-bottom: 0;
}
.judelbtn {
  position: relative;
  float: right;
  margin-left: 20px;
  top: -4px;
}
.judelbtn span {
  color: #999 !important;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}
.el-checkbox-group label span {
  font-size: 14px !important;
  font-weight: normal !important;
}
.el-dialog__body .el-form-item__content button span {
  font-size: 14px !important;
  color: #fff !important;
  font-weight: normal !important;
}
.judelbtnitem,
.dotdisplay {
  position: absolute;
  width: 100px;
  z-index: 999;
  padding: 10px 0;
  background-color: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.judelbtnitem:after,
.dotdisplay:after {
  position: absolute;
  display: block;
  content: "";
  top: -6px;
  left: 42px;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-right: none;
  border-bottom: none;
  transform: rotate(45deg);
  background-color: #fff;
}
.judelbtnitem p,
.dotdisplay p {
  height: 25px;
  cursor: pointer;
  line-height: 25px;
  text-align: center;
}
.judelbtnitem p:hover,
.dotdisplay p:hover {
  color: #00a1d6;
  background-color: #e5e9ef;
}
.judelbtn .judelbtnitem,
.dotdisplay {
  top: 33px;
  left: -40px;
}
.dotdel {
  float: left;
  margin-left: 0;
}

/*share window*/
.sharetofriend {
  position: absolute;
  width: 136px;
  left: 59px;
  top: 45px;
  height: 150px;
  padding: 10px;
  border-radius: 4px;
  z-index: 10;
  background-color: #fff;
  border: 1px solid #ebebeb;
  box-sizing: border-box;
  transition: all 0.5s ease;
  box-shadow: 0 5px 20px rgba(26, 26, 26, 0.1);
}
#sharefrienf {
  display: none;
}
.sharetofriend a {
  position: relative;
  display: block;
  margin: 0 !important;
  text-align: center;
  font-size: 14px;
  color: #8590a6;
  height: 40px !important;
  width: 100%;
  padding: 0;
  z-index: 1;
  line-height: 40px !important;
  cursor: pointer;
  box-sizing: border-box;
}

.sharetofriend .arrowfix {
  position: absolute;
  display: inline-blick;
  width: 15px;
  height: 15px;
  top: -9px;
  left: 62px;
  transform: rotate(45deg);
  border: 1px solid #ebebeb;
  border-right: none;
  border-bottom: none;
  background-color: #fff;
}

.touchright p {
  clear: both;
  font-size: 12px;
  color: #999;
  padding-right: 10px;
}
.touchright p span {
  margin-left: 15px;
}
.touchright p b {
  font-size: 16px;
  color: #000;
  margin-left: 5px;
}
.touchright .shareds {
  float: left;
  width: 65px;
  height: 30px;
  border-radius: 2px;
  color: #447bf9;
  font-size: 12px;
  margin: 0 0 24px 142px;
  border: 1px solid rgba(68, 123, 249, 1);
  box-sizing: border-box;
  background-color: #fff;
}
.touchright .shareds img {
  width: 12px;
  height: 12px;
  vertical-align: middle;
}
.touchright .addsheq {
  float: left;
  width: 86px;
  height: 30px;
  color: #fff;
  margin-left: 15px;
  background: rgba(68, 123, 249, 1);
  border-radius: 2px;
}

.collect0,
.collect1 {
  float: left;
  display: inline-block;
  width: 18px;
  height: 18px;
  margin-right: 5px;
  cursor: pointer;
}
.collect0 {
  background: url("/static/noszan.svg") no-repeat;
  background-size: cover;
}
.collect1 {
  background: url("/static/collect.svg") no-repeat;
  background-size: cover;
}
.addcollect0 {
  background: url("/static/zanicon.svg") no-repeat;
  background-size: cover;
}
.addcollect1 {
  background: url("/static/collection.svg") no-repeat;
  background-size: cover;
}

.parentShare {
  position: relative;
}
.icon-douban,
.icon-qzone {
  display: none !important;
}
.social-share {
  position: absolute;
  width: 146px;
  top: 0;
  left: 0;
  height: 64px;
  z-index: 9999;
  border-radius: 4px;
  margin-left: 56px;
  padding: 10px 5px 10px 10px;
  box-shadow: 0 5px 20px rgba(26, 26, 26, 0.1);
  background-color: #fff;
  border: 1px solid #ebebeb;
  box-sizing: border-box;
}
.social-share:after {
  position: absolute;
  display: block;
  content: "";
  top: -6px;
  left: 67px;
  width: 10px;
  height: 10px;
  border: 1px solid #ebebeb;
  border-radius: 2px;
  border-right: none;
  border-bottom: none;
  transform: rotate(45deg);
  background-color: #fff;
}

textarea::-webkit-input-placeholder {
  color: #999;
  font-size: 14px;
}
textarea::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #999;
  font-size: 14px;
}
textarea:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #999;
  font-size: 14px;
}
textarea:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #999;
  font-size: 14px;
}

.sendcomment input::-webkit-input-placeholder {
  color: #8690a6;
  font-size: 16px;
}
.sendcomment input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #8690a6;
  font-size: 16px;
}
.sendcomment input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #8690a6;
  font-size: 16px;
}
.sendcomment input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #8690a6;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/subject/discussDetails.vue